// Settings tab: editing the first and last name (Name.vue, in a FieldPair layer like the
// affiliation). Shared with the dialog footer (OK, Cancel). The drafts live in local storage while
// typing, preferred on reopening; confirming saves and clears them, discarding clears them.

import {reactive, ref} from "vue";
import {useLocalStorage} from "@vueuse/core";

// Clerk's limit for first_name and last_name (each); 257 is refused (422; tested 2026-10-11)
export const NAME_MAX_LENGTH = 256;

const isEditingName = ref(false);
const nameDrafts = reactive({
  firstName: useLocalStorage("profile-draft-first-name", ""),
  lastName: useLocalStorage("profile-draft-last-name", "")
});

// each draft keeps what was typed, else the saved name
function openName(user) {
  if (!isEditingName.value) nameDrafts.firstName = nameDrafts.firstName || user?.firstName || "";
  if (!isEditingName.value) nameDrafts.lastName = nameDrafts.lastName || user?.lastName || "";
  isEditingName.value = true;
}

function discardName() {
  nameDrafts.firstName = "";
  nameDrafts.lastName = "";
  isEditingName.value = false;
}

function getIsChanged(user, firstName, lastName) {
  return firstName !== (user?.firstName || "") || lastName !== (user?.lastName || "");
}

// footer OK or Enter: saves a changed name (never an empty one), then closes and clears the drafts
async function confirmName(user) {
  const firstName = nameDrafts.firstName.trim();
  const lastName = nameDrafts.lastName.trim();
  const isToSave = Boolean(firstName || lastName) && getIsChanged(user, firstName, lastName);
  try {
    if (isToSave) await user.update({firstName, lastName});
  } catch {
    return false; // stays open to retry
  }
  discardName();
  return true;
}

export function useNameEdit() {
  return {isEditingName, nameDrafts, openName, discardName, confirmName};
}
